import React, { useState, useEffect } from "react";
import { columns } from "../../constants/rbacManagement";
import CustomPopupForm from "../customPopupModel";
import BasicCustomTable from "../basicTable";
import CustomButton from "../elements/CustomButton/CustomButton";
import { useSnackbar } from "../SnackbarContext";
import axiosInstance from "../../configuration/request";
import { useSelector } from "react-redux";
import { getRbscManagementPermissions } from "../../utils/rolesAndPermissions";

const DIALOG_TYPES = {
  CREATE: "create-employee",
  DELETE: "delete",
};

export function EmployeeTable({ usertype, storeId }) {
  const showSnackbar = useSnackbar();
  const [users, setUsers] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [mode, setMode] = useState("create");
  const [selectedRow, setSelectedRow] = useState(null);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const permissions = useSelector((state) => state.counter.permissions);
  const rolePermissions = permissions?.[0]?.permissions || [];
  const {  canEdit, canCreate, canDelete } =
    getRbscManagementPermissions(rolePermissions);

  const finalColumns = React.useMemo(() => {
    if (!canEdit && !canDelete) {
      return columns.filter((col) => col.field !== "action");
    }
    return columns;
  }, [canEdit, canDelete]);

  useEffect(() => {
    fetchUsers(page, rowsPerPage);
  }, []);

  const fetchUsers = async (pageNumber, limit) => {
    try {
      let url = "";
      if (usertype === "business user" && storeId) {
        url += `/customer/store/employees?userType=employee user&shopId=${storeId}`;
      } else if (usertype === "admin") {
        url = `customer/users?usertype=${usertype}&isApproved=approved`;
      } else {
        url = "";
      }

      if (url) {
  url += `&page=${pageNumber}&limit=${limit}`;
}
      const res = await axiosInstance.get(url);
      const formatted = res?.data?.data.map((item) => ({
        id: item?.id || "",
        name: item?.name || "",
        email: item?.email || "",
        phone: item?.phone_number || "",
        gender: item?.gender || "",
        birth_date: item?.dob || "",
        designtation: item?.roles?.[0]?.name || "-",
        status: item?.user_status ? "Active" : "Inactive",
        address: item?.addresses?.[0],
        roles: item?.roles || [],
      }));
      setUsers(formatted);
      setPage(Number(res?.data?.page) || 0);
      setTotalCount(res?.data?.total || 0);
    } catch (error) {
        if(error?.response?.data?.message){
          showSnackbar(error?.response?.data?.message, "error");
        }else{
          showSnackbar("Something went wrong!", "error");
        }
    }
  };

  const handlePageChangeRequest = (newPage, newRowsPerPage) => {
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
    fetchUsers(newPage, newRowsPerPage);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setDialogType("");
  };

  const handleCreate = () => {
    setMode("create");
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleEdit = (row) => {
    setMode("edit");
    setSelectedRow(row);
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setDialogType(DIALOG_TYPES.DELETE);
    setOpenDialog(true);
  };

  const handleDeleteConfirm = async (id) => {
    try {
      await axiosInstance.delete(`customer/users/${id}`);
      showSnackbar("User deleted successfully!", "success");
      fetchUsers(page,rowsPerPage);
    } catch (error) {
      showSnackbar("Something went wrong!", "error");
    } finally {
      handleCloseDialog();
    }
  };

  const handleSubmit = () => {
    handleCloseDialog();
     fetchUsers(page,rowsPerPage);
  };


  return (
    <>
      <div className="flex justify-end w-full mb-2 pr-2">
        {canCreate && (
          <CustomButton
            onClick={handleCreate}
            customeClass="gradient-button w-[140px] h-[45px]"
          >
            <span className="text-xl mr-[4px]">+</span>Create
          </CustomButton>
        )}
      </div>
      <div className="px-2 pt-1 pb-4 h-[calc(100vh-260px)]">
        <BasicCustomTable
          columns={finalColumns}
          rows={users}
          onEdit={handleEdit}
          onDelete={handleDelete}
          colorHeader
          customClassHeader="table-header-cell-colored"
          tableName="employee"
          maxHeightClass="max-h-[calc(100vh-345px)]"
          backendPagination
          totalCount={totalCount}
          onPageChangeRequest={handlePageChangeRequest}
          pageLimit={rowsPerPage}
          page={page}
          canEdit={canEdit}
          canDelete={canDelete}
          handleFilter={(filter) =>{console.log(filter)}}
        />
      </div>

      {dialogType === DIALOG_TYPES.CREATE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.CREATE}
          mode={mode}
          dialogDetails={{
            data: selectedRow,
            userType: usertype,
            shopId: storeId,
          }}
          onSubmit={handleSubmit}
        />
      )}

      {dialogType === DIALOG_TYPES.DELETE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.DELETE}
          onDelete={handleDeleteConfirm}
          dialogDetails={{
            title: "Delete Confirmation",
            content: "Are you sure you want to delete this user?",
            rowData: selectedRow,
          }}
        />
      )}
    </>
  );
}

export default EmployeeTable;
